<div class="login-form">
  <form ngForm>
    <img src="../../assets/images/physioLife logo artwork-02.png" class="center"
      style="border: #0e173f 1px solid; border-radius: 15px;">
    <br>
      <h2 class="text-center" style="color: #431a2a;"> Welcome Back! </h2>
      @if (loading) {
        <div class="lds-ripple">
          <div></div>
          <div></div>
        </div>
      }
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="email" name="email" class="form-control" id="email" placeholder="Type your email address"
          required="required" [(ngModel)]="email">
      </div>
      <div class="d-grid gap-2">
        <button class="btn btn-warning" type="button" (click)="getPassword()">Send</button>
      </div>
    </form>
    <div class="mb-3">
      @if (message && !success) {
        <div class="alert" role="alert"
          style="color: #fad8da; text-align: center; background-color: #431a2a;">
          {{ message }}
        </div>
      }
      @if (message && success) {
        <div class="alert" role="alert"
          style="color: #fad8da; text-align: center; background-color: #173f28;">
          {{ message }}
          <br>
            @if (success) {
              <a [routerLink]="['/login']">Go to login page</a>
            }
          </div>
        }
      </div>
    </div>